import { useEffect, useState } from 'react';
import style from './Transcript.module.scss';
import { selectedTranscript } from '@/store/selectedTranscript';

interface TranscriptListProps {
  items: TranscriptListItem[];
}

export interface TranscriptListItem {
  id?: string;
  duration?: string;
  datetime?: string;
  asr_model?: string;
}

const TranscriptList = ({ items }: TranscriptListProps) => {
  const [activeItem, setActiveItem] = useState<number>(0);

  const handleClick = (index: number) => {
    setActiveItem(index);
    const clickedItem = items[index];

    if (clickedItem) {
      selectedTranscript.value = clickedItem;
    }
  };

  useEffect(() => {
    if (Object.keys(selectedTranscript.value).length !== 0) {
      selectedTranscript.value = {};
    }

    // Select the first transcript item when the component is loaded
    if (items?.length > 0 && selectedTranscript.value.id !== items[0].id) {
      handleClick(0);
    }
  }, [items]);

  return (
    <div>
      <ul className={style.transcript__list__items}>
        {items?.map((item, index) => (
          <li
            key={index}
            className={`${style.transcript__list__item} ${
              index === activeItem ? style.transcript__list__item__active : ''
            }`}
            onClick={() => handleClick(index)}
          >
            {index + 1}_{item.duration}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TranscriptList;
